<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" id="myTab" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link active w-100" id="employers-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
        role="tab" aria-controls="home" aria-selected="true">
        Employers
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" id="employer-onboarding-tab" data-bs-toggle="tab" data-bs-target="#profile"
        type="button" role="tab" aria-controls="profile" aria-selected="false">
        Employer Onboarding Requests
        <span class="badge bg-danger ms-1">{{this.filteredOnboardingRequests.length}}</span>
      </button>
    </li>
  </ul>

  <!-- Tab Contents -->
  <div class="tab-content mt-3" id="myTabContent">

    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="employers-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3 mt-3 g-2">
            <!-- Search — full width on mobile & tablet, 8 cols on desktop -->
            <div class="col-12 col-lg-8 mb-2 mb-lg-0">
              <div class="position-relative">
                <input id="searchUser" type="text" class="form-control employer-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="searchText" (input)="performSearch()" />
                <span class="search-icon" (click)="performSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>

            <!-- Employer Type Filter — shares row with button on tablet -->
            <div class="col-8 col-lg-2 mb-2 mb-lg-0">
              <select class="form-select filter-bar-select shadow-none" [(ngModel)]="filterEmployerTypeId"
                (change)="onEmployerTypeFilterChange()">
                <option value="">All Types</option>
                <ng-container *ngFor="let entry of TYPE_MAP | keyvalue">
                  <option [value]="entry.key">{{ entry.value }}</option>
                </ng-container>
              </select>
            </div>

            <!-- Advanced Filter — sits next to select on tablet -->
            <div class="col-4 col-lg-2">
              <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                (filterApplied)="onFilter($event)" (filterCleared)="onClear()">
              </app-filter-panel>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isEmpLoading" class="text-muted">Loading users...</div>
          <!-- Empty State -->
          <div *ngIf="(filteredEmployers.length === 0 || empError) && !isEmpLoading" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Employers Found.</p>
          </div>

          <!-- Table -->
          <div *ngIf="filteredEmployers.length > 0 && !empError" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">CIXOR Ref. Number</th>
                  <th class="table-title text-start">Business Reg. No.</th>
                  <th class="table-title text-start">Name</th>
                  <th class="table-title text-start">Contact Number</th>
                  <th class="table-title text-center">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employer of pagedEmployers">
                  <td class="table-data-text text-start">{{ employer.cixorReferenceNumber }}</td>
                  <td class="table-data-text text-start">{{ employer.companyRegNo }}</td>
                  <td class="table-data-text text-start">{{ employer.companyName }}</td>
                  <td class="table-data-text text-start">{{ employer.landLineNumber }}</td>
                  <td class="table-data-text text-center">
                    <!-- Employers table action button -->
                    <button class="btn p-0" style="background: none; border: none;" data-bs-toggle="offcanvas"
                      data-bs-target="#employerProfileOffcanvas" aria-controls="employerProfileOffcanvas"
                      (click)="openEmployerProfile(employer.companyId)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <!-- <app-paginator [dataSource]="filteredEmployers" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onEmployerPageChange($event)">
            </app-paginator> -->
            <app-paginator [serverSide]="true" [totalItems]="totalEmployers" [pageSize]="employersPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onEmployerPageChange($event)">
            </app-paginator>

          </div>

        </div>
      </div>
    </div>

    <!-- Employer Creation Requests -->
    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="employer-onboarding-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3 mt-3">

            <!-- Search -->
            <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
              <div class="position-relative">
                <input id="searchUser" type="text" class="form-control employer-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="searhchOnboardingText"
                  (input)="performOnboardingRequestSearch()" />
                <span class="search-icon" (click)="performOnboardingRequestSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isObrLoading" class="text-muted">Loading onboarding requests...</div>
          <!-- Empty State -->
          <div *ngIf="(filteredOnboardingRequests.length === 0 || obrError) && !isObrLoading" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Onboarding Requests Found.</p>
          </div>

          <!-- Table -->
          <div *ngIf="filteredOnboardingRequests.length > 0 && !obrError" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">Employer Name</th>
                  <th class="table-title text-start">Contact Person</th>
                  <th class="table-title text-start">Email</th>
                  <th class="table-title text-start">Contact Number</th>
                  <th class="table-title text-center">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let request of pagedOnboardingRequests">
                  <td class="table-data-text text-start">{{ request.companyName }}</td>
                  <td class="table-data-text text-start">{{ request.initialContactFirstName + ' ' +
                    request.initialContactLastName}}</td>
                  <td class="table-data-text text-start">{{ request.email }}</td>
                  <td class="table-data-text text-start">{{ formatPhones(request) }}</td>
                  <td class="table-data-text text-center">
                    <button class="btn p-0" style="background: none; border: none;" data-bs-toggle="offcanvas"
                      data-bs-target="#employerFormOffcanvas" aria-controls="employerFormOffcanvas"
                      (click)="viewOnboardingRequest(request)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <!-- <app-paginator [dataSource]="filteredOnboardingRequests" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onOnboardingRequestPageChange($event)">
            </app-paginator> -->
            <app-paginator [serverSide]="true" [totalItems]="totalOnboardingRequests" [pageSize]="onboardingPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onOnboardingRequestPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<!-- Employer Profile - Full View Offcanvas -->
<div #employerProfileOffcanvasEl class="offcanvas offcanvas-end w-100 w-lg-75" tabindex="-1"
  id="employerProfileOffcanvas" aria-labelledby="employerProfileOffcanvasLabel" data-bs-backdrop="static"
  data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="d-flex align-items-center gap-2">
      <i class="bi bi-buildings fs-5"></i>
      <div>
        <h5 class="offcanvas-title mb-0" id="employerProfileOffcanvasLabel">
          Employer Profile — {{ selectedCompanyProfile?.basicRegistration?.companyName || '-' }}
        </h5>
        <small class="text-muted">
          CIXOR Ref: {{ selectedCompanyProfile?.basicRegistration?.cixorReferenceNumber || '-' }}
        </small>
      </div>
    </div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">
    <!-- Loading skeleton -->
    <ng-container *ngIf="profileLoading">
      <div class="row g-3">
        <!-- Left column skeleton -->
        <div class="col-lg-8">
          <!-- Basic Registration -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="row">
              <div class="col-sm-4 skeleton-gap-2">
                <div class="skeleton-line w-75"></div>
                <div class="skeleton-line w-50"></div>
                <div class="skeleton-line w-60"></div>
                <div class="skeleton-line w-40"></div>
                <div class="skeleton-line w-50"></div>
              </div>
              <div class="col-sm-8 skeleton-gap-2">
                <div class="skeleton-line w-50"></div>
                <div class="skeleton-line w-75"></div>
                <div class="skeleton-line w-60"></div>
                <div class="skeleton-line w-40"></div>
                <div class="skeleton-line w-50"></div>
              </div>
            </div>
          </div>

          <!-- Contact Details -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
              <div class="skeleton-line w-60"></div>
            </div>
          </div>

          <!-- Financial Snapshot -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-50"></div>
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-25"></div>
            </div>
          </div>

          <!-- Authorized Contact + Documents -->
          <div class="skeleton-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2 mb-3">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
            </div>
            <!-- doc rows -->
            <div class="skeleton-row">
              <div class="skeleton-line w-100"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-line w-75"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-line w-50"></div>
            </div>
          </div>
        </div>

        <!-- Right column skeleton -->
        <div class="col-lg-4">
          <!-- Logo -->
          <div class="skeleton-card text-center mb-3">
            <div class="d-flex justify-content-center">
              <div class="skeleton-rect w-75"></div>
            </div>
          </div>

          <!-- Bank Accounts -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-line w-100"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-line w-75"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-line w-50"></div>
            </div>
          </div>

          <!-- Secretary -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
            </div>
          </div>

          <!-- Auditor -->
          <div class="skeleton-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Error -->
    <div *ngIf="!profileLoading && profileError" class="text-danger">{{ profileError }}</div>

    <!-- Actual content -->
    <ng-container *ngIf="!profileLoading && !profileError && selectedCompanyProfile as p">
      <!-- (keep your existing content here as-is) -->
    </ng-container>


    <ng-container *ngIf="!profileLoading && !profileError && selectedCompanyProfile as p">
      <div class="row g-3">

        <!-- Left column -->
        <div class="col-lg-6">
          <!-- Basic Registration -->
          <div class="card shadow-sm border-0 mb-3 info-card-glow">
            <div class="card-body">
              <h6>Basic Registration</h6>
              <hr class="mb-3">
              <dl class="row mb-0">
                <dt class="col-sm-4">Company ID</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.companyId }}</dd>

                <dt class="col-sm-4">Registered No.</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.companyRegNo || '-' }}</dd>

                <dt class="col-sm-4">Trading Name</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.companyTradingName || '-' }}</dd>

                <dt class="col-sm-4">Operating Address</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.operatingAddress || '-' }}</dd>

                <dt class="col-sm-4">Created</dt>
                <dd class="col-sm-8">
                  {{ p.basicRegistration?.createdDate ? (p.basicRegistration.createdDate | date: 'yyyy-MM-dd, h:mm:ss
                  a') :'-' }}
                </dd>

                <dt class="col-sm-4">Legal Type</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.legalTypeDescription ?? '-' }}</dd>

                <dt class="col-sm-4">Industry</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.mainIndustryDescription ?? '-' }}</dd>

                <dt class="col-sm-4">Employees</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.noOfEmployeesCategory ?? '-' }}</dd>

                <dt class="col-sm-4">Initial Contact Person</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.initialContactFirstName + ' ' +
                  p.basicRegistration?.initialContactLastName }}</dd>

                <dt class="col-sm-4"></dt>
                <dd class="col-sm-8">
                  <a *ngIf="p.basicRegistration?.email" [href]="'mailto:' + p.basicRegistration?.email">
                    {{ p.basicRegistration?.email }}
                  </a>
                  <span *ngIf="!p.basicRegistration?.email">-</span>
                </dd>

                <dt class="col-sm-4"></dt>
                <dd class="col-sm-8">
                  <ng-container
                    *ngIf="p.basicRegistration?.landLineNumber || p.basicRegistration?.mobileNumber01 || p.basicRegistration?.mobileNumber02; else noPhones">
                    <div *ngIf="p.basicRegistration?.landLineNumber as ln">
                      <span class="text-muted me-1">Land:</span>
                      <a [href]="'tel:' + ln">{{ ln }}</a>
                    </div>
                    <div *ngIf="p.basicRegistration?.mobileNumber01 as m1">
                      <span class="text-muted me-1">Mobile:</span>
                      <a [href]="'tel:' + m1">{{ m1 }}</a>
                    </div>
                    <!-- <div *ngIf="p.basicRegistration?.mobileNumber02 as m2">
                      <span class="text-muted me-1">Mobile 2:</span>
                      <a [href]="'tel:' + m2">{{ m2 }}</a>
                    </div> -->
                  </ng-container>
                  <ng-template #noPhones>-</ng-template>
                </dd>

                <!-- <dt class="col-sm-4">Status</dt>
                <dd class="col-sm-8">
                  <span class="badge" [ngClass]="p.basicRegistration?.isActive ? 'bg-success' : 'bg-secondary'">
                    {{ p.basicRegistration?.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </dd> -->
              </dl>
            </div>
          </div>

          <!-- Company Employee and Payroll Details -->
          <div class="card shadow-sm border-0 mb-3 info-card-glow">
            <div class="card-body">
              <h6>Employee and Payroll Details</h6>
              <hr class="mb-3">
              <dl class="row mb-0">
                <dt class="col-sm-4">No of Active Employees</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.noOfActiveEmployees ?? 0 }}</dd>

                <dt class="col-sm-4">No of Resigned Employees</dt>
                <dd class="col-sm-8">{{ p.basicRegistration?.noOfResignedEmployees ?? 0 }}</dd>

                <dt class="col-sm-4">Current Month Payroll</dt>
                <dd class="col-sm-8">{{ (p.basicRegistration?.totalCostToCompanyCurrentMonth ?? 0) | currency:'LKR
                  ':'symbol':'1.2-2' }}</dd>
              </dl>
            </div>
          </div>

          <!-- Contact Details -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="sectionCardClass(p.contactDetails)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Contact Details</h6>
                <span class="badge" [ngClass]="sectionStatusClass(p.contactDetails)">
                  {{ sectionStatusLabel(p.contactDetails) }}
                </span>
              </div>
              <hr class="mb-3">

              <!-- meta -->
              <div class="small text-muted mb-2" *ngIf="p.contactDetails">
                <!-- <div *ngIf="p.contactDetails.isReviewed">
                  Reviewed on:
                  {{ p.contactDetails.reviewedOn ? (p.contactDetails.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                  by {{ p.contactDetails.reviewedBy ?? '-' }}
                  <span *ngIf="p.contactDetails.reviewerRemark"> — "{{ p.contactDetails.reviewerRemark }}"</span>
                </div> -->
                <!-- <div *ngIf="!p.contactDetails.isReviewed && p.contactDetails.requestedOn">
                  Requested on: {{ p.contactDetails.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                </div> -->
              </div>

              <ng-container *ngIf="p.contactDetails; else noContact">
                <dl class="row mb-0">
                  <dt class="col-sm-4">Land Phone</dt>
                  <dd class="col-sm-8">
                    <ng-container *ngIf="p.contactDetails?.landPhone; else noLand">
                      <ng-container *ngIf="isSectionApproved(p.contactDetails); else landPlain">
                        <a [href]="'tel:' + p.contactDetails.landPhone">{{ p.contactDetails.landPhone }}</a>
                      </ng-container>
                      <ng-template #landPlain>{{ p.contactDetails.landPhone }}</ng-template>
                    </ng-container>
                    <ng-template #noLand>-</ng-template>
                  </dd>

                  <dt class="col-sm-4">Mobile Phone</dt>
                  <dd class="col-sm-8">
                    <ng-container *ngIf="p.contactDetails?.mobilePhone; else noMob">
                      <ng-container *ngIf="isSectionApproved(p.contactDetails); else mobPlain">
                        <a [href]="'tel:' + p.contactDetails.mobilePhone">{{ p.contactDetails.mobilePhone }}</a>
                      </ng-container>
                      <ng-template #mobPlain>{{ p.contactDetails.mobilePhone }}</ng-template>
                    </ng-container>
                    <ng-template #noMob>-</ng-template>
                  </dd>

                  <dt class="col-sm-4">Email</dt>
                  <dd class="col-sm-8">
                    <ng-container *ngIf="p.contactDetails?.email; else noEmail">
                      <ng-container *ngIf="isSectionApproved(p.contactDetails); else emailPlain">
                        <a [href]="'mailto:' + p.contactDetails.email">{{ p.contactDetails.email }}</a>
                      </ng-container>
                      <ng-template #emailPlain>{{ p.contactDetails.email }}</ng-template>
                    </ng-container>
                    <ng-template #noEmail>-</ng-template>
                  </dd>

                  <dt class="col-sm-4">Website</dt>
                  <dd class="col-sm-8">
                    <ng-container *ngIf="p.contactDetails?.website; else noSite">
                      <ng-container *ngIf="isSectionApproved(p.contactDetails); else sitePlain">
                        <a [href]="p.contactDetails.website" target="_blank" rel="noopener">
                          {{ p.contactDetails.website }}
                        </a>
                      </ng-container>
                      <ng-template #sitePlain>{{ p.contactDetails.website }}</ng-template>
                    </ng-container>
                    <ng-template #noSite>-</ng-template>
                  </dd>
                </dl>
              </ng-container>
              <!-- actions -->
              <div *ngIf="p.contactDetails?.isReviewed === false" class="d-flex justify-content-end gap-1 mb-3">
                <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('contactDetails', p.contactDetails, true)">
                  <i class="bi bi-check2-circle me-1"></i>Approve
                </button>
                <button class="btn btn-sm btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('contactDetails', p.contactDetails, false)">
                  <i class="bi bi-x-circle me-1"></i>Reject
                </button>
              </div>
              <ng-template #noContact>
                <div class="text-muted small">No contact details</div>
              </ng-template>
            </div>
          </div>

          <!-- Financial Snapshot -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="sectionCardClass(p.financialSnapshot)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Financial Snapshot</h6>
                <span class="badge" [ngClass]="sectionStatusClass(p.financialSnapshot)">
                  {{ sectionStatusLabel(p.financialSnapshot) }}
                </span>
              </div>
              <hr class="mb-3">

              <!-- <div class="small text-muted mb-2" *ngIf="p.financialSnapshot">
                <div *ngIf="p.financialSnapshot.isReviewed">
                  Reviewed on:
                  {{ p.financialSnapshot.reviewedOn ? (p.financialSnapshot.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-'
                  }}
                  by {{ p.financialSnapshot.reviewedBy ?? '-' }}
                  <span *ngIf="p.financialSnapshot.reviewerRemark"> — "{{ p.financialSnapshot.reviewerRemark }}"</span>
                </div>
                <div *ngIf="!p.financialSnapshot.isReviewed && p.financialSnapshot.requestedOn">
                  Requested on: {{ p.financialSnapshot.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </div> -->

              <ng-container *ngIf="p.financialSnapshot; else noFin">
                <dl class="row mb-0">
                  <dt class="col-sm-4">Annual Turnover</dt>
                  <dd class="col-sm-8">LKR {{ ( (p.financialSnapshot?.annualTurnover) | number: '1.2-2' ) ?? '-' }}</dd>

                  <dt class="col-sm-4">Salary Bill Range</dt>
                  <dd class="col-sm-8">
                    {{ p.financialSnapshot?.rangeLabel || '-' }}
                    <ng-container
                      *ngIf="p.financialSnapshot?.minAmount !== null && p.financialSnapshot?.maxAmount !== null">
                      ( {{ p.financialSnapshot?.minAmount | number: '1.2-2' }} - {{ p.financialSnapshot?.maxAmount |
                      number: '1.2-2' }} )
                    </ng-container>
                  </dd>

                  <dt class="col-sm-4">Max Salary Advance %</dt>
                  <dd class="col-sm-8">{{ p.financialSnapshot?.maxAllowedSalaryAdvancePct ?? '-' }}</dd>
                </dl>
              </ng-container>

              <div *ngIf="p.financialSnapshot?.isReviewed === false" class="d-flex justify-content-end gap-1 mb-3">
                <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('financialSnapshot', p.financialSnapshot, true)">
                  <i class="bi bi-check2-circle me-1"></i>Approve
                </button>
                <button class="btn btn-sm btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('financialSnapshot', p.financialSnapshot, false)">
                  <i class="bi bi-x-circle me-1"></i>Reject
                </button>
              </div>

              <ng-template #noFin>
                <div class="text-muted small">No financial data</div>
              </ng-template>
            </div>
          </div>

          <!-- Authorized Contact -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="sectionCardClass(p.authorizedContact)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Authorized Contact</h6>
                <span class="badge" [ngClass]="sectionStatusClass(p.authorizedContact)">
                  {{ sectionStatusLabel(p.authorizedContact) }}
                </span>
              </div>
              <hr class="mb-3">

              <!-- <div class="small text-muted mb-2" *ngIf="p.authorizedContact">
                <div *ngIf="p.authorizedContact.isReviewed">
                  Reviewed on:
                  {{ p.authorizedContact.reviewedOn ? (p.authorizedContact.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-'
                  }}
                  by {{ p.authorizedContact.reviewedBy ?? '-' }}
                  <span *ngIf="p.authorizedContact.reviewerRemark"> — "{{ p.authorizedContact.reviewerRemark }}"</span>
                </div>
                <div *ngIf="!p.authorizedContact.isReviewed && p.authorizedContact.requestedOn">
                  Requested on: {{ p.authorizedContact.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </div> -->

              <ng-container *ngIf="p.authorizedContact; else noAuthContact">
                <dl class="row mb-0">
                  <dt class="col-sm-4">Name</dt>
                  <dd class="col-sm-8">
                    {{ p.authorizedContact?.title + ' ' + p.authorizedContact?.firstName + ' ' +
                    p.authorizedContact?.lastName }}
                  </dd>

                  <dt class="col-sm-4">Contact Numbers</dt>
                  <dd class="col-sm-8">
                    <ng-container
                      *ngIf="p.authorizedContact?.contactNumber01 || p.authorizedContact?.contactNumber02; else noAuthPhones">
                      <div *ngIf="p.authorizedContact?.contactNumber01 as c1">
                        <span class="text-muted me-1">Primary:</span>
                        <ng-container *ngIf="isSectionApproved(p.authorizedContact); else ac1Plain">
                          <a [href]="'tel:' + c1">{{ c1 }}</a>
                        </ng-container>
                        <ng-template #ac1Plain>{{ c1 }}</ng-template>
                      </div>
                      <div *ngIf="p.authorizedContact?.contactNumber02 as c2">
                        <span class="text-muted me-1">Alternate:</span>
                        <ng-container *ngIf="isSectionApproved(p.authorizedContact); else ac2Plain">
                          <a [href]="'tel:' + c2">{{ c2 }}</a>
                        </ng-container>
                        <ng-template #ac2Plain>{{ c2 }}</ng-template>
                      </div>
                    </ng-container>
                    <ng-template #noAuthPhones>-</ng-template>
                  </dd>

                  <dt class="col-sm-4">Email</dt>
                  <dd class="col-sm-8">
                    <ng-container *ngIf="p.authorizedContact?.emailAddress; else noAuthEmail">
                      <ng-container *ngIf="isSectionApproved(p.authorizedContact); else acEmailPlain">
                        <a [href]="'mailto:' + p.authorizedContact.emailAddress">{{ p.authorizedContact.emailAddress
                          }}</a>
                      </ng-container>
                      <ng-template #acEmailPlain>{{ p.authorizedContact.emailAddress }}</ng-template>
                    </ng-container>
                    <ng-template #noAuthEmail>-</ng-template>
                  </dd>

                  <dt class="col-sm-4">ID</dt>
                  <dd class="col-sm-8">
                    {{ p.authorizedContact?.idType || '-' }} {{ p.authorizedContact?.idNumber || '' }}
                  </dd>
                </dl>
                <!-- …inside Authorized Contact card, after the <dl> and before the review buttons… -->
                <div *ngIf="isSectionApproved(p.authorizedContact) && p.authorizedContact?.emailAddress"
                  class="d-flex justify-content-end mt-3">
                  <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                    (click)="openOnboardConfirm(p)">
                    <i class="bi bi-person-gear me-1"></i>
                    Onboard Super Admin
                  </button>
                </div>

              </ng-container>

              <div *ngIf="p.authorizedContact?.isReviewed === false" class="d-flex justify-content-end gap-1 mb-3">
                <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('authorizedContact', p.authorizedContact, true)">
                  <i class="bi bi-check2-circle me-1"></i>Approve
                </button>
                <button class="btn btn-sm btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('authorizedContact', p.authorizedContact, false)">
                  <i class="bi bi-x-circle me-1"></i>Reject
                </button>
              </div>

              <ng-template #noAuthContact>
                <div class="text-muted small">No authorized contact</div>
              </ng-template>
            </div>
          </div>

          <!-- Secretary -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="sectionCardClass(p.secretary)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Secretary</h6>
                <span class="badge" [ngClass]="sectionStatusClass(p.secretary)">
                  {{ sectionStatusLabel(p.secretary) }}
                </span>
              </div>
              <hr class="mb-3">

              <!-- <div class="small text-muted mb-2" *ngIf="p.secretary">
                <div *ngIf="p.secretary.isReviewed">
                  Reviewed on:
                  {{ p.secretary.reviewedOn ? (p.secretary.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                  by {{ p.secretary.reviewedBy ?? '-' }}
                  <span *ngIf="p.secretary.reviewerRemark"> — "{{ p.secretary.reviewerRemark }}"</span>
                </div>
                <div *ngIf="!p.secretary.isReviewed && p.secretary.requestedOn">
                  Requested on: {{ p.secretary.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </div> -->

              <div class="text-muted small" *ngIf="!p.secretary">No secretary</div>
              <div *ngIf="p.secretary">
                <div><strong>{{ p.secretary?.secretaryCompanyName || '-' }}</strong></div>
                <div>{{ p.secretary?.contactPersonName || '-' }}</div>
                <div>
                  <ng-container *ngIf="p.secretary?.contactNumber01 || p.secretary?.contactNumber02; else noSecPhones">
                    <div *ngIf="p.secretary?.contactNumber01 as s1">
                      <span class="text-muted me-1">Primary:</span>
                      <ng-container *ngIf="isSectionApproved(p.secretary); else s1Plain">
                        <a [href]="'tel:' + s1">{{ s1 }}</a>
                      </ng-container>
                      <ng-template #s1Plain>{{ s1 }}</ng-template>
                    </div>
                    <div *ngIf="p.secretary?.contactNumber02 as s2">
                      <span class="text-muted me-1">Alternate:</span>
                      <ng-container *ngIf="isSectionApproved(p.secretary); else s2Plain">
                        <a [href]="'tel:' + s2">{{ s2 }}</a>
                      </ng-container>
                      <ng-template #s2Plain>{{ s2 }}</ng-template>
                    </div>
                  </ng-container>
                  <ng-template #noSecPhones>-</ng-template>
                </div>
                <div>
                  <ng-container *ngIf="p.secretary?.emailAddress; else noSecEmail">
                    <ng-container *ngIf="isSectionApproved(p.secretary); else secEmailPlain">
                      <a [href]="'mailto:' + p.secretary.emailAddress">{{ p.secretary.emailAddress }}</a>
                    </ng-container>
                    <ng-template #secEmailPlain>{{ p.secretary.emailAddress }}</ng-template>
                  </ng-container>
                  <ng-template #noSecEmail>-</ng-template>
                </div>
              </div>

              <div *ngIf="p.secretary?.isReviewed === false" class="d-flex justify-content-end gap-1 mb-3">
                <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('secretary', p.secretary, true)">
                  <i class="bi bi-check2-circle me-1"></i>Approve
                </button>
                <button class="btn btn-sm btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('secretary', p.secretary, false)">
                  <i class="bi bi-x-circle me-1"></i>Reject
                </button>
              </div>

            </div>
          </div>

          <!-- Auditor -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="sectionCardClass(p.auditor)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Auditor</h6>
                <span class="badge" [ngClass]="sectionStatusClass(p.auditor)">
                  {{ sectionStatusLabel(p.auditor) }}
                </span>
              </div>
              <hr class="mb-3">

              <!-- <div class="small text-muted mb-2" *ngIf="p.auditor">
                <div *ngIf="p.auditor.isReviewed">
                  Reviewed on:
                  {{ p.auditor.reviewedOn ? (p.auditor.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                  by {{ p.auditor.reviewedBy ?? '-' }}
                  <span *ngIf="p.auditor.reviewerRemark"> — "{{ p.auditor.reviewerRemark }}"</span>
                </div>
                <div *ngIf="!p.auditor.isReviewed && p.auditor.requestedOn">
                  Requested on: {{ p.auditor.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </div> -->

              <div class="text-muted small" *ngIf="!p.auditor">No auditor</div>
              <div *ngIf="p.auditor">
                <div><strong>{{ p.auditor?.auditorCompanyName || '-' }}</strong></div>
                <div>{{ p.auditor?.contactPersonName || '-' }}</div>
                <div>
                  <ng-container *ngIf="p.auditor?.contactNumber01 || p.auditor?.contactNumber02; else noAudPhones">
                    <div *ngIf="p.auditor?.contactNumber01 as a1">
                      <span class="text-muted me-1">Primary:</span>
                      <ng-container *ngIf="isSectionApproved(p.auditor); else a1Plain">
                        <a [href]="'tel:' + a1">{{ a1 }}</a>
                      </ng-container>
                      <ng-template #a1Plain>{{ a1 }}</ng-template>
                    </div>
                    <div *ngIf="p.auditor?.contactNumber02 as a2">
                      <span class="text-muted me-1">Alternate:</span>
                      <ng-container *ngIf="isSectionApproved(p.auditor); else a2Plain">
                        <a [href]="'tel:' + a2">{{ a2 }}</a>
                      </ng-container>
                      <ng-template #a2Plain>{{ a2 }}</ng-template>
                    </div>
                  </ng-container>
                  <ng-template #noAudPhones>-</ng-template>
                </div>
                <div>
                  <ng-container *ngIf="p.auditor?.emailAddress; else noAudEmail">
                    <ng-container *ngIf="isSectionApproved(p.auditor); else audEmailPlain">
                      <a [href]="'mailto:' + p.auditor.emailAddress">{{ p.auditor.emailAddress }}</a>
                    </ng-container>
                    <ng-template #audEmailPlain>{{ p.auditor.emailAddress }}</ng-template>
                  </ng-container>
                  <ng-template #noAudEmail>-</ng-template>
                </div>
              </div>

              <div *ngIf="p.auditor?.isReviewed === false" class="d-flex justify-content-end gap-1 mb-3">
                <button class="btn btn-sm btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('auditor', p.auditor, true)">
                  <i class="bi bi-check2-circle me-1"></i>Approve
                </button>
                <button class="btn btn-sm btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                  (click)="reviewSection('auditor', p.auditor, false)">
                  <i class="bi bi-x-circle me-1"></i>Reject
                </button>
              </div>

            </div>
          </div>

          <!-- Employer Type Card -->
          <div class="card border-0 mb-3 info-card-glow">
            <div class="card-body">
              <h6 class="mb-1">Employer Type</h6>
              <p class="text-muted small mb-3">Select and change the employer type</p>
              <hr class="mb-3">

              <div class="row g-3">
                <!-- CIXOR Payday -->
                <div class="col-6">
                  <div class="employer-type-option" [class.selected]="pendingIsPayDay"
                    (click)="toggleEmployerTypeCheckbox('payday', p)">
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <div class="type-checkbox" [class.active]="pendingIsPayDay">
                        <i class="bi bi-check-lg" *ngIf="pendingIsPayDay"></i>
                      </div>
                      <span class="fw-semibold type-label">CIXOR Payday</span>
                    </div>
                    <p class="text-muted small mb-0">Instant wage access with optional payroll support</p>
                  </div>
                </div>

                <!-- CIXOR Payroll -->
                <div class="col-6">
                  <div class="employer-type-option" [class.selected]="pendingIsPayRoll"
                    (click)="toggleEmployerTypeCheckbox('payroll', p)">
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <div class="type-checkbox" [class.active]="pendingIsPayRoll">
                        <i class="bi bi-check-lg" *ngIf="pendingIsPayRoll"></i>
                      </div>
                      <span class="fw-semibold type-label">CIXOR Payroll</span>
                    </div>
                    <p class="text-muted small mb-0">Smart payroll management for modern businesses</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- EWW Access Block Card -->
          <div class="card border-0 mb-3 eww-access-card" [ngClass]="isEwwBlocked ? 'state-blocked' : 'state-active'">
            <div class="card-body px-4 py-3">
          
              <!-- Header Row -->
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                  <span class="eww-icon">
                    <i [class]="isEwwBlocked ? 'bi bi-shield-x' : 'bi bi-shield-check'"></i>
                  </span>
                  <div>
                    <h6 class="mb-0 fw-semibold">EWW Access Control</h6>
                    <p class="text-muted small mb-0">Manage earned wage withdrawal access for this employer</p>
                  </div>
                </div>
                <span class="eww-badge" [ngClass]="isEwwBlocked ? 'eww-badge--blocked' : 'eww-badge--active'">
                  {{ isEwwBlocked ? 'Blocked' : 'Active' }}
                </span>
              </div>
          
              <hr class="my-3">
          
              <!-- Status + Action Row -->
              <div class="d-flex align-items-center justify-content-between">
                <p class="small mb-0 eww-status-text" [ngClass]="isEwwBlocked ? 'text-danger' : 'text-success'">
                  <i [class]="isEwwBlocked ? 'bi bi-x-circle me-1' : 'bi bi-check-circle me-1'"></i>
                  {{ isEwwBlocked ? 'Access is currently blocked for all employees.' : 'Access is currently active for all
                  employees.' }}
                </p>
          
                <button class="btn btn-sm eww-action-btn ms-3"
                  [ngClass]="isEwwBlocked ? 'eww-action-btn--restore' : 'eww-action-btn--block'" [disabled]="isEwwBlockSaving"
                  (click)="onEWWBlockToggle()">
                  <span *ngIf="isEwwBlockSaving" class="spinner-border spinner-border-sm me-1"></span>
                  <i *ngIf="!isEwwBlockSaving" [class]="isEwwBlocked ? 'bi bi-unlock me-1' : 'bi bi-slash-circle me-1'"></i>
                  {{ isEwwBlocked ? 'Restore Access' : 'Block Access' }}
                </button>
              </div>
          
            </div>
          </div>

          <!-- CRIB Consent Statement Section - Add this after the Auditor card -->
          <!-- <div class="card border-0 mb-3 crib-consent-card card-status-success">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 crib-title">
                  <i class="bi bi-shield-check me-2"></i>CRIB Consent Statement
                </h6> -->
          <!-- <span class="badge" [ngClass]="p.cribstm ? 'badge-success' : 'badge-warning'">
                  <i [ngClass]="p.cribstm ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-circle-fill'"
                    class="me-1"></i>
                  {{ p.cribstm ? 'Consented' : 'Pending Consent' }}
                </span> -->
          <!-- </div>

              <div class="crib-info-banner mb-3">
                <i class="bi bi-info-circle-fill"></i>
                <span>Credit Information Authorization</span>
              </div>

              <div class="crib-consent-content">
                <div class="consent-section mb-3">
                  <p class="consent-text">
                    I hereby <strong>authorize Sarvodaya Development Finance PLC</strong> to obtain and verify my credit
                    information
                    from the <strong>Credit Information Bureau of Sri Lanka (CRIB)</strong> and to share my personal and
                    financial
                    information with CRIB for:
                  </p>
                  <ul class="consent-purposes">
                    <li>Credit evaluation</li>
                    <li>Monitoring</li>
                    <li>Regulatory purposes</li>
                  </ul>
                  <p class="consent-text small-note">
                    In accordance with applicable laws of Sri Lanka.
                  </p>
                </div>

                <div class="consent-section mb-3">
                  <p class="consent-text">
                    <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                    I understand that this consent is <strong>required to provide financial services</strong> and that
                    it shall remain
                    valid during my relationship with <strong>CIXOR Pvt Ltd</strong>.
                  </p>
                </div>

                <div class="consent-divider"></div>

                <div class="custom-checkbox-wrapper">
                  <label class="custom-checkbox-container"
                    [ngClass]="{'checked-state': p.basicRegistration.cribConsentAgreed}">
                    <input type="checkbox" [checked]="p.basicRegistration.cribConsentAgreed === true" disabled
                      id="cribConsentCheckbox">
                    <span class="checkmark">
                      <i class="bi bi-check-lg check-icon"></i>
                    </span>
                    <span class="checkbox-label">
                      <strong>I agree</strong> and give my consent for Sarvodaya Development Finance PLC to access and
                      share
                      my credit information with CRIB.
                    </span>
                  </label>
                </div> -->

          <!-- Show consent date if available -->
          <!-- <div *ngIf="p.cribstm && p.cribConsentDate" class="consent-date-info mt-3">
                  <i class="bi bi-calendar-check-fill text-success me-2"></i>
                  <span><strong>Consented on:</strong> {{ p.cribConsentDate | date:'MMMM dd, yyyy \'at\' hh:mm a'
                    }}</span>
                </div>
              </div>
            </div>
          </div> -->

        </div>

        <!-- Right column -->
        <div class="col-lg-6">
          <!-- Logo -->
          <!-- <div class="card shadow-sm border-0 mb-3">
            <div class="card-body text-center">
              <div *ngIf="p.basicRegistration?.companyLogo; else noLogo">
                <img [src]="p.basicRegistration?.companyLogo" alt="Company Logo" class="img-fluid rounded"
                  style="max-height: 120px; object-fit: contain;" />
              </div>
              <ng-template #noLogo>
                <div class="text-muted small">No company logo</div>
              </ng-template>
            </div>
          </div> -->

          <!-- Documents (per-item status + actions) -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="listCardClass(p.documents)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Documents</h6>
                <span class="badge d-inline-flex align-items-center gap-0" [ngClass]="listStatusClass(p.documents)">
                  {{ listStatusLabel(p.documents) }}
                  <button *ngIf="isAnyRejected(p.documents)" type="button"
                    class="btn btn-link btn-sm p-0 m-0 lh-1 text-reset" [attr.aria-pressed]="showRejected.documents"
                    (click)="toggleRejected('documents')" title="Toggle rejected items"><i class="rejected-eye-icon"
                      [ngClass]="showRejected.documents ? 'bi-eye' : 'bi-eye-slash'"></i></button>
                </span>
              </div>
              <hr class="mb-3">

              <ng-container *ngIf="p.documents?.length; else noDocs">
                <ul class="list-unstyled mb-0">
                  <li *ngFor="let d of filteredList('documents', p.documents)" class="mb-3 p-2 rounded"
                    [ngClass]="itemRowClass(d)">
                    <div class="d-flex justify-content-between align-items-start gap-3">
                      <div class="flex-grow-1">
                        <i class="bi bi-file-earmark-text me-2"></i>
                        <strong class="text-wrap">{{ d.documentTitle }}</strong>

                        <!-- View link only if APPROVED -->
                        <ng-container *ngIf="d.fileUrl">
                          <ng-container>
                            <button type="button" class="btn btn-link btn-sm ms-2 p-0 align-baseline"
                              (click)="viewDocument(p.basicRegistration?.companyId, d)">
                              View
                            </button>
                          </ng-container>
                        </ng-container>

                        <!-- <div class="small text-muted mt-1">
                          <span *ngIf="!d.isReviewed && d.requestedOn">
                            Requested: {{ d.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                          </span>
                          <span *ngIf="d.isReviewed">
                            Reviewed: {{ d.reviewedOn ? (d.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                            by {{ d.reviewedBy ?? '-' }}
                            <span *ngIf="d.reviewerRemark"> — "{{ d.reviewerRemark }}"</span>
                          </span>
                        </div> -->
                      </div>

                      <div class="text-end">
                        <span class="badge d-block mb-2" [ngClass]="itemStatusClass(d)">{{ itemStatusLabel(d) }}</span>
                        <div *ngIf="d.isReviewed === false" class="btn-group btn-group-sm">
                          <button class="btn btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                            (click)="reviewItem('documents', d, true)">Approve</button>
                          <button class="btn btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                            (click)="reviewItem('documents', d, false)">Reject</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </ng-container>
              <ng-template #noDocs>
                <div class="text-muted small">No documents</div>
              </ng-template>
            </div>
          </div>


          <!-- Bank Accounts (per-row status + actions) -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="listCardClass(p.bankAccounts)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Bank Accounts</h6>
                <span class="badge d-inline-flex align-items-center gap-0" [ngClass]="listStatusClass(p.bankAccounts)">
                  {{ listStatusLabel(p.bankAccounts) }}
                  <button *ngIf="isAnyRejected(p.bankAccounts)" type="button"
                    class="btn btn-link btn-sm p-0 m-0 lh-1 text-reset" [attr.aria-pressed]="showRejected.bankAccounts"
                    (click)="toggleRejected('bankAccounts')" title="Toggle rejected items"><i class="rejected-eye-icon"
                      [ngClass]="showRejected.bankAccounts ? 'bi-eye' : 'bi-eye-slash'"></i></button>
                </span>
              </div>
              <hr class="mb-3">

              <ul class="list-unstyled mb-0" *ngIf="p.bankAccounts?.length">
                <li *ngFor="let b of filteredList('bankAccounts', p.bankAccounts)"
                  class="mb-2 p-2 rounded d-flex justify-content-between align-items-start" [ngClass]="itemRowClass(b)">

                  <div class="me-3">
                    <strong class="text-wrap">{{ b.accountNumber }}</strong>
                    <span *ngIf="b.isPrimaryAccount"
                      class="badge ms-2 text-primary border border-primary bg-transparent rounded-pill px-2">
                      Primary
                    </span>
                    <div class="small text-wrap">
                      {{ b.bankName }} | {{ b.branchName }}
                    </div>
                    <!-- <div class="small text-muted mt-1">
                      <span *ngIf="!b.isReviewed && b.requestedOn">Req: {{ b.requestedOn | date:'yyyy-MM-dd HH:mm'
                        }}</span>
                      <span *ngIf="b.isReviewed">
                        Rev: {{ b.reviewedOn ? (b.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                        by {{ b.reviewedBy ?? '-' }}
                        <span *ngIf="b.reviewerRemark"> — "{{ b.reviewerRemark }}"</span>
                      </span>
                    </div> -->
                  </div>

                  <div class="text-end">
                    <span class="badge d-block mb-2" [ngClass]="itemStatusClass(b)">{{ itemStatusLabel(b) }}</span>
                    <div *ngIf="b.isReviewed === false" class="btn-group btn-group-sm">
                      <button class="btn btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('bankAccounts', b, true)">Approve</button>
                      <button class="btn btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('bankAccounts', b, false)">Reject</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>




          <!-- Directors (per-item status + actions) -->
          <div class="card border-0 mb-3 info-card-glow" [ngClass]="listCardClass(p.directors)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Directors</h6>
                <span class="badge d-inline-flex align-items-center gap-0" [ngClass]="listStatusClass(p.directors)">
                  {{ listStatusLabel(p.directors) }}
                  <button *ngIf="isAnyRejected(p.directors)" type="button"
                    class="btn btn-link btn-sm p-0 m-0 lh-1 text-reset" [attr.aria-pressed]="showRejected.directors"
                    (click)="toggleRejected('directors')" title="Toggle rejected items"><i class="rejected-eye-icon"
                      [ngClass]="showRejected.directors ? 'bi-eye' : 'bi-eye-slash'"></i></button>
                </span>
              </div>
              <hr class="mb-3">

              <div class="text-muted small" *ngIf="!p.directors?.length">No directors</div>
              <ul class="list-unstyled mb-0" *ngIf="p.directors?.length">
                <li *ngFor="let d of filteredList('directors', p.directors)"
                  class="mb-2 p-2 rounded d-flex justify-content-between align-items-start" [ngClass]="itemRowClass(d)">
                  <div class="me-3">
                    <div class="d-flex align-items-center gap-2"><strong class="text-nowrap">Name:</strong><span>{{ d.directorName }}</span></div>
                    <div class="d-flex align-items-center gap-2 small text-muted"><strong class="text-nowrap">NIC:</strong><span>{{ d.directorNIC ?? 'N/A' }}</span></div>
                    <!-- <div class="small text-muted">
                      <span *ngIf="!d.isReviewed && d.requestedOn">
                        Req: {{ d.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                      </span>
                      <span *ngIf="d.isReviewed">
                        Rev: {{ d.reviewedOn ? (d.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                        by {{ d.reviewedBy ?? '-' }}
                        <span *ngIf="d.reviewerRemark"> — "{{ d.reviewerRemark }}"</span>
                      </span>
                    </div> -->
                  </div>
                  <div class="text-end">
                    <span class="badge d-block mb-2" [ngClass]="itemStatusClass(d)">{{ itemStatusLabel(d) }}</span>
                    <div *ngIf="d.isReviewed === false" class="btn-group btn-group-sm">
                      <button class="btn btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('directors', d, true)">Approve</button>
                      <button class="btn btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('directors', d, false)">Reject</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- Shareholders (per-item status + actions) -->
          <div class="card border-0 mb-0 info-card-glow" [ngClass]="listCardClass(p.shareholders)">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Shareholders</h6>
                <span class="badge d-inline-flex align-items-center gap-0" [ngClass]="listStatusClass(p.shareholders)">
                  {{ listStatusLabel(p.shareholders) }}
                  <button *ngIf="isAnyRejected(p.shareholders)" type="button"
                    class="btn btn-link btn-sm p-0 m-0 lh-1 text-reset" [attr.aria-pressed]="showRejected.shareholders"
                    (click)="toggleRejected('shareholders')" title="Toggle rejected items"><i class="rejected-eye-icon"
                      [ngClass]="showRejected.shareholders ? 'bi-eye' : 'bi-eye-slash'"></i></button>
                </span>
              </div>
              <hr class="mb-3">

              <div class="text-muted small" *ngIf="!p.shareholders?.length">No shareholders</div>
              <ul class="list-unstyled mb-0" *ngIf="p.shareholders?.length">
                <li *ngFor="let s of filteredList('shareholders', p.shareholders)"
                  class="mb-2 p-2 rounded d-flex justify-content-between align-items-start" [ngClass]="itemRowClass(s)">
                  <div class="me-3">
                    <div class="d-flex align-items-center gap-2"><strong class="text-nowrap">Name:</strong><span>{{ s.shareholderName }}</span></div>
                    <div class="d-flex align-items-center gap-2 small text-muted"><strong class="text-nowrap">NIC:</strong><span>{{ s.shareholderNIC ?? 'N/A' }}</span></div>
                    <!-- <div class="small text-muted">
                      <span *ngIf="!s.isReviewed && s.requestedOn">
                        Req: {{ s.requestedOn | date:'yyyy-MM-dd HH:mm' }}
                      </span>
                      <span *ngIf="s.isReviewed">
                        Rev: {{ s.reviewedOn ? (s.reviewedOn | date:'yyyy-MM-dd HH:mm') : '-' }}
                        by {{ s.reviewedBy ?? '-' }}
                        <span *ngIf="s.reviewerRemark"> — "{{ s.reviewerRemark }}"</span>
                      </span>
                    </div> -->
                  </div>
                  <div class="text-end">
                    <span class="badge d-block mb-2" [ngClass]="itemStatusClass(s)">{{ itemStatusLabel(s) }}</span>
                    <div *ngIf="s.isReviewed === false" class="btn-group btn-group-sm">
                      <button class="btn btn-outline-success" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('shareholders', s, true)">Approve</button>
                      <button class="btn btn-outline-danger" *ngIf="authService.canReview('clients.employer')"
                        (click)="reviewItem('shareholders', s, false)">Reject</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>


        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Employer Onboarding Request - Compact Offcanvas -->
<div #employerFormOffcanvasEl class="offcanvas offcanvas-end" id="employerFormOffcanvas" tabindex="-1"
  aria-labelledby="employerFormOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false"
  style="--bs-offcanvas-width: 700px;"> <!-- make it smaller -->

  <div class="offcanvas-header">
    <div class="d-flex align-items-center gap-2">
      <i class="bi bi-briefcase-check fs-5"></i>
      <div>
        <h5 class="offcanvas-title mb-0" id="employerFormOffcanvasLabel">
          Onboarding Request — {{ selectedRequest?.companyName || '-' }}
        </h5>
        <small class="text-muted">
          CIXOR Ref: {{ selectedRequest?.cixorReferenceNumber || '-' }}
        </small>
      </div>
    </div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body p-3">
    <ng-container *ngIf="selectedRequest as r; else noSel">

      <!-- Status Banner -->
      <div class="pending-status-banner mb-4">
        <div class="d-flex align-items-center gap-2 ps-2">
          <div class="pending-pulse-dot"></div>
          <span class="pending-status-text">Awaiting Review</span>
        </div>
        <span class="pending-status-reg" *ngIf="r.companyRegNo">
          Reg No: {{ r.companyRegNo }}
        </span>
      </div>

      <!-- Profile Card -->
      <div class="obr-profile-card mb-3">

        <!-- Card Header -->
        <div class="obr-profile-header">
          <div class="obr-profile-logo">
            <i class="bi bi-building"></i>
          </div>
          <div class="obr-profile-header-text">
            <div class="obr-profile-name">{{ r.companyName }}</div>
            <div class="obr-profile-meta">
              {{ r.legalTypeDescription ?? 'Company' }}<ng-container *ngIf="r.mainIndustryDescription"> · {{ r.mainIndustryDescription }}</ng-container>
            </div>
          </div>
          <!--<span class="obr-profile-status-badge">
            <span class="obr-profile-status-dot"></span>
            Awaiting Review
          </span>-->
        </div>

        <!-- Two-column grid body -->
        <div class="obr-profile-body">

          <!-- Registration column -->
          <div class="obr-profile-section">
            <p class="obr-col-title">Registration</p>
            <div class="obr-field">
              <span class="obr-field-label">Company ID</span>
              <span class="obr-field-value obr-mono">{{ r.companyId }}</span>
            </div>
            <div class="obr-field">
              <span class="obr-field-label">Reg. Number</span>
              <span class="obr-field-value obr-mono">{{ r.companyRegNo || '-' }}</span>
            </div>
            <div class="obr-field">
              <span class="obr-field-label">Trading Name</span>
              <span class="obr-field-value">{{ r.companyTradingName || '-' }}</span>
            </div>
            <div class="obr-field">
              <span class="obr-field-label">Employees</span>
              <span class="obr-field-value">{{ r.noOfEmployeesCategory || (r.noOfEmployees ?? '-') }}</span>
            </div>
          </div>

          <!-- Classification column -->
          <div class="obr-profile-section obr-profile-section--right">
            <p class="obr-col-title">Classification</p>
            <div class="obr-field">
              <span class="obr-field-label">Employer Type</span>
              <span class="obr-employer-type-pill">{{ r.employerTypeDescription ?? '-' }}</span>
            </div>
            <div class="obr-field">
              <span class="obr-field-label">Industry</span>
              <span class="obr-field-value">{{ r.mainIndustryDescription || (r.mainIndustry ?? '-') }}</span>
            </div>
            <div class="obr-field">
              <span class="obr-field-label">Legal Type</span>
              <span class="obr-field-value">{{ r.legalTypeDescription ?? '-' }}</span>
            </div>
            <div class="obr-field obr-field--block">
              <span class="obr-field-label">Address</span>
              <span class="obr-field-value">{{ r.operatingAddress || '-' }}</span>
            </div>
          </div>

          <!-- Full-width divider -->
          <div class="obr-profile-divider"></div>

          <!-- Contact section (full width) -->
          <div class="obr-contact-section">
            <p class="obr-col-title" style="margin-bottom: 10px;">Initial Contact</p>

            <!-- Person header -->
            <div class="obr-person-header">
              <div class="obr-avatar">
                {{ (r.initialContactFirstName?.[0] ?? '') + (r.initialContactLastName?.[0] ?? '') | uppercase }}
              </div>
              <div>
                <div class="obr-person-name">
                  {{ r.initialContactFirstName + ' ' + r.initialContactLastName }}
                </div>
                <div class="obr-person-role">Primary contact</div>
              </div>
            </div>

            <!-- Contact tiles: email row + phones row -->
            <div class="obr-contact-tiles">

              <!-- Row 1: Email (full width) -->
              <div class="obr-contact-tile obr-tile--email obr-tile--full" (click)="copyContact(r.email, 'email')"
                [title]="r.email || 'No email'">
                <div class="obr-tile-icon">
                  <i class="bi bi-envelope-fill"></i>
                </div>
                <div class="obr-tile-detail">
                  <span class="obr-tile-type">Email</span>
                  <span class="obr-tile-value">{{ r.email || '—' }}</span>
                </div>
              </div>

              <!-- Row 2: Phones -->
              <div class="obr-tiles-phone-row">

                <!-- Landline -->
                <div class="obr-contact-tile obr-tile--phone" (click)="copyContact(r.landLineNumber, 'land')"
                  *ngIf="r.landLineNumber" [title]="r.landLineNumber">
                  <div class="obr-tile-icon">
                    <i class="bi bi-telephone-fill"></i>
                  </div>
                  <div class="obr-tile-detail">
                    <span class="obr-tile-type">Landline</span>
                    <span class="obr-tile-value">{{ r.landLineNumber }}</span>
                  </div>
                </div>

                <!-- Mobile 1 -->
                <div class="obr-contact-tile obr-tile--mobile" (click)="copyContact(r.mobileNumber01, 'mob1')"
                  *ngIf="r.mobileNumber01" [title]="r.mobileNumber01">
                  <div class="obr-tile-icon">
                    <i class="bi bi-phone-fill"></i>
                  </div>
                  <div class="obr-tile-detail">
                    <span class="obr-tile-type">Mobile</span>
                    <span class="obr-tile-value">{{ r.mobileNumber01 }}</span>
                  </div>
                </div>

                <!-- Mobile 2 -->
                <div class="obr-contact-tile obr-tile--mobile" (click)="copyContact(r.mobileNumber02, 'mob2')"
                  *ngIf="r.mobileNumber02" [title]="r.mobileNumber02">
                  <div class="obr-tile-icon">
                    <i class="bi bi-phone-fill"></i>
                  </div>
                  <div class="obr-tile-detail">
                    <span class="obr-tile-type">Mobile 2</span>
                    <span class="obr-tile-value">{{ r.mobileNumber02 }}</span>
                  </div>
                </div>

                <!-- No phones fallback -->
                <div class="obr-contact-tile obr-tile--phone obr-tile--disabled"
                  *ngIf="!r.landLineNumber && !r.mobileNumber01 && !r.mobileNumber02">
                  <div class="obr-tile-icon"><i class="bi bi-telephone"></i></div>
                  <div class="obr-tile-detail">
                    <span class="obr-tile-type">Phones</span>
                    <span class="obr-tile-value" style="color: var(--bottom-text-blue)">No phone numbers</span>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <!-- Footer meta row -->
          <div class="obr-meta-row">
            <span class="obr-meta-text">
              <i class="bi bi-clock me-1"></i>
              Submitted {{ r.createdDate ? (r.createdDate | date: 'yyyy-MM-dd, h:mm a') : '-' }}
            </span>
            <span class="obr-copy-feedback" [class.obr-copied]="obrCopiedField !== null">
              {{ obrCopiedField !== null ? 'Copied!' : 'Click a tile to copy' }}
            </span>
          </div>

        </div>
      </div>

      <!-- Actions -->
      <div class="approval-actions-bar" *ngIf="authService.canReview('clients.employer')">
        <button type="button" class="btn approval-btn-reject" (click)="rejectSelectedRequest()">
          <i class="bi bi-x-circle"></i>
          Reject
        </button>
        <button type="button" class="btn approval-btn-approve" (click)="approveSelectedRequest()">
          <i class="bi bi-check-circle"></i>
          Approve
        </button>
      </div>

    </ng-container>

    <ng-template #noSel>
      <div class="text-muted">No request selected.</div>
    </ng-template>
  </div>
</div>



<!-- Document Preview Modal -->
<div #docPreviewModal class="modal fade" id="docPreviewModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">
          {{ preview.fileName || 'Document Preview' }}
          <span class="badge bg-secondary ms-2" *ngIf="preview.mimeType">{{ preview.mimeType }}</span>
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body p-0" style="min-height:60vh;">
        <div *ngIf="isPreviewLoading" class="p-4 text-center text-muted">
          <div class="spinner-border me-2" role="status" aria-hidden="true"></div>
          Loading...
        </div>

        <div *ngIf="previewError" class="alert alert-danger m-3">
          {{ previewError }}
        </div>

        <iframe *ngIf="!isPreviewLoading && !previewError && previewSafeUrl" [src]="previewSafeUrl"
          style="width:100%;height:70vh;border:0;"></iframe>
      </div>

      <div class="modal-footer">
        <a *ngIf="downloadUrl" [href]="downloadUrl" [attr.download]="preview.fileName || null" class="btn btn-primary">
          <i class="bi bi-download me-1"></i> Download
        </a>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Confirm Onboard Super Admin (simple, wide, centered) -->
<div #confirmOnboardModal class="modal fade" id="confirmOnboardModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="--bs-modal-width: 760px;">
    <div class="modal-content border-0 rounded-4 shadow-lg">

      <!-- header banner (only colored area) -->
      <div class="p-4 rounded-top-4"
        style="background:linear-gradient(135deg,rgba(25,135,84,.12),rgba(25,135,84,.04));">
        <div class="d-flex align-items-center">
          <div class="rounded-circle d-inline-flex align-items-center justify-content-center me-3"
            style="width:44px;height:44px;background:#19875412;">
            <i class="bi bi-shield-lock" style="font-size:1.15rem;color:#198754;"></i>
          </div>
          <div>
            <h5 class="mb-0">Onboard Super Admin</h5>
            <small class="text-muted">Create the primary administrator for this company</small>
          </div>
        </div>
      </div>

      <!-- body (plain paragraphs, no sub-cards) -->
      <div class="modal-body px-4 py-4">
        <p class="mb-2 fw-semibold">Are you sure you want to onboard a Super Admin?</p>

        <p class="mb-3 text-muted">
          This will grant full access to the following person for
          <strong class="text-body">{{ onboardPreview.companyName || '-' }}</strong>.
        </p>

        <p class="mb-1">
          <span class="text-muted">Name:</span>
          <span class="text-body fw-medium">{{ onboardPreview.firstName }} {{ onboardPreview.lastName }}</span>
        </p>
        <p class="mb-1">
          <span class="text-muted">Email:</span>
          <span class="text-body fw-medium">{{ onboardPreview.email || '-' }}</span>
        </p>
        <p class="mb-3">
          <span class="text-muted">Mobile:</span>
          <span class="text-body fw-medium">{{ onboardPreview.mobile || '-' }}</span>
        </p>

        <p class="small text-muted mb-0">
          A company can have only <strong>one</strong> active <strong>Super Admin</strong>.
        </p>

      </div>

      <!-- footer (no X button; Close + Continue) -->
      <div class="modal-footer border-0 px-4 pb-4 pt-0">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success" [disabled]="isOnboarding" (click)="confirmOnboardSuperAdmin()">
          <span *ngIf="isOnboarding" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          Continue
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Confirm Employer Type Change Modal -->
<div #confirmEmployerTypeModal class="modal fade" id="confirmEmployerTypeModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="--bs-modal-width: 480px;">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-banner d-flex align-items-center gap-3">
        <div class="icon-wrap">
          <i class="bi bi-arrow-left-right"></i>
        </div>
        <div>
          <h5 class="mb-0">Change Employer Type</h5>
          <small>This action will update the employer's system type</small>
        </div>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <p class="confirm-headline">
          You are about to change the employer type for
          <strong>{{ selectedCompanyProfile?.basicRegistration?.companyName || '-' }}</strong>.
        </p>

        <!-- From → To row -->
        <div class="type-transition">
          <span class="type-chip from">
            <i class="bi bi-record-circle"></i>
            {{ currentCombinationLabel || '-' }}
          </span>
          <i class="bi bi-arrow-right arrow-icon"></i>
          <span class="type-chip to">
            <i class="bi bi-record-circle-fill"></i>
            {{ pendingCombinationLabel }}
          </span>
        </div>

        <!-- Warning -->
        <div class="warn-note">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>This may affect how the employer's employees access payroll and wage features.</span>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" (click)="cancelEmployerTypeChange()">
          Cancel
        </button>
        <button type="button" class="btn btn-confirm" [disabled]="isUpdatingEmployerType"
          (click)="confirmEmployerTypeChange()">
          <span *ngIf="isUpdatingEmployerType" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          Confirm Change
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ─── EWW Block Modal (requires reason) ─────────────────────────────────── -->
<div #ewwBlockModal class="modal fade" id="ewwBlockModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="--bs-modal-width: 480px;">
    <div class="modal-content eww-modal-content">

      <div class="eww-modal-banner block-banner d-flex align-items-center gap-3">
        <div class="eww-icon-wrap block-icon">
          <i class="bi bi-shield-x"></i>
        </div>
        <div>
          <h5 class="mb-0">Block EWW Access</h5>
          <small>Restrict EWW for all employees</small>
        </div>
      </div>

      <div class="modal-body px-4 py-3">
        <p class="confirm-body-text">
          You are about to <strong>block EWW access</strong> for
          <strong>{{ selectedCompanyProfile?.basicRegistration?.companyName || '-' }}</strong>.
        </p>

        <div class="eww-warn-note mb-3">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>All employees of this employer will be unable to access EWW until manually unblocked.</span>
        </div>

        <div>
          <label class="form-label small fw-semibold">
            Block Reason <span class="text-danger">*</span>
          </label>
          <textarea class="form-control form-control-sm" rows="3"
            placeholder="Enter the reason for blocking EWW access..."
            [(ngModel)]="ewwBlockReason" maxlength="100"></textarea>
          <div class="form-text text-end text-muted" style="font-size: 0.75rem;">
            {{ ewwBlockReason.length }}/100
          </div>
        </div>
      </div>

      <div class="modal-footer border-0 px-4 pb-4 pt-1 gap-2">
        <button type="button" class="btn eww-btn-cancel" data-bs-dismiss="modal" (click)="cancelEWWBlock()">
          Cancel
        </button>
        <button type="button" class="btn eww-btn-block"
          [disabled]="isEwwBlockSaving || !ewwBlockReason.trim()"
          (click)="confirmEWWBlock()">
          <span *ngIf="isEwwBlockSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Block Access
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ─── EWW Unblock Confirm Modal (confirmation only) ─────────────────────── -->
<div #ewwUnblockModal class="modal fade" id="ewwUnblockModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="--bs-modal-width: 440px;">
    <div class="modal-content eww-modal-content">

      <div class="eww-modal-banner unblock-banner d-flex align-items-center gap-3">
        <div class="eww-icon-wrap unblock-icon">
          <i class="bi bi-shield-check"></i>
        </div>
        <div>
          <h5 class="mb-0">Unblock EWW Access</h5>
          <small>Restore EWW for all employees</small>
        </div>
      </div>

      <div class="modal-body px-4 py-3">
        <p class="confirm-body-text">
          You are about to <strong>restore EWW access</strong> for
          <strong>{{ selectedCompanyProfile?.basicRegistration?.companyName || '-' }}</strong>.
        </p>

        <div class="eww-info-note">
          <i class="bi bi-info-circle-fill"></i>
          <span>All employees of this employer will regain access to EWW immediately.</span>
        </div>
      </div>

      <div class="modal-footer border-0 px-4 pb-4 pt-1 gap-2">
        <button type="button" class="btn eww-btn-cancel" data-bs-dismiss="modal" (click)="cancelEWWUnblock()">
          Cancel
        </button>
        <button type="button" class="btn eww-btn-unblock"
          [disabled]="isEwwBlockSaving"
          (click)="confirmEWWUnblock()">
          <span *ngIf="isEwwBlockSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Confirm Unblock
        </button>
      </div>

    </div>
  </div>
</div>